//credit to stack overflow for a lot of this one. http://stackoverflow.com/questions/24707508/angularjs-set-global-ngmodeloptions#answer-26537212

/**
 * @ngdoc directive
 * @name WebCoreModule.directive:ngModelDirective
 * @description
 * The ngModelDirective is a decorative directive mainly for HTML control operations,
 * this directive is responsible for set blur option in HTML fields.
 */


angular.module('WebCoreModule').config(['$provide', function($provide) {

	$provide.decorator('ngModelDirective', ['$delegate', function($delegate) {
		var directive = $delegate[0];
		var link = directive.link; // jshint ignore:line
		var shouldSetBlurUpdateEvent = function (element) {
			// The blur event is only really applicable to input controls so
			// we want to stick with the default events for selects, checkboxes & radio buttons.
			// also stick with default events for typeahead controls and the ui-select

			var nodeName = element.nodeName.toLowerCase();
			//for some reason comments end up in here at times. short circuit this if that's the case.
			if(element.nodeName.toLowerCase() === '#comment') return false;
			var nodeType = undefined;
			if(typeof element.type === 'string') {
				nodeType = element.type.toLowerCase();
			}

			return	(nodeName === 'textarea' && !element.hasAttribute('maxlength')) ||
					(nodeName === 'div' && !element.classList.contains('ui-select-bootstrap') && !element.hasAttribute('wc-data-table') && !element.hasAttribute('uib-datepicker-popup-wrap')) ||
					(nodeName === 'input' && nodeType !== 'checkbox' && nodeType !== 'radio' && !element.hasAttribute('uib-typeahead') && !element.hasAttribute('uib-datepicker-popup'));
		};

		// save a reference to the original compile function
		var compileFn = directive.compile;
		directive.compile = function() {
			var link = compileFn.apply(this, arguments);
			return {
				pre: function ngModelPostLink(scope, element, attr, ctrls) {
					// jshint unused:true
					if(!ctrls[2]) {
						ctrls[2] = {};
					}
					var ngModelOptions = ctrls[2];
					if (ngModelOptions.$options === undefined && shouldSetBlurUpdateEvent(element[0])) {
						ngModelOptions.$options = {
							updateOn: 'blur',
							updateOnDefault: false
						};
					}
					link.pre.apply(this, arguments);
				},
				post: link.post
			};
		};

		return $delegate;
	}]);
}]);